import styled from 'styled-components';

import {
  SelectIdField,
  TagField,
  UrgencyIdField,
  RadioButtonField,
  TextareaField,
  PrecautionFields,
} from '~fields';

const OperatingRoomCleanForm = props => {
  const { operatingRooms } = props;
  const setFieldValue = props.formik.setFieldValue;
  const operatingRoomOptions = operatingRooms.map(room => ({
    label: room.clinicalName,
    value: room.id,
  }));

  const handleTaskSubTypeChange = value => {
    switch (value) {
      case 'WYIW7FJC': // välisiivous
        setFieldValue('urgency', 'URGN');
        break;
      case 'QMJ10VS6': // loppusiivous
        setFieldValue('urgency', 'DFLT');
        break;
      default:
        setFieldValue('urgency', null);
        break;
    }
  };

  return (
    <Wrapper>
      <SelectIdField
        name="room"
        options={operatingRoomOptions}
        fallbackPlaceholder="Valitse..."
        required
      />

      <TagField
        name="taskSubType"
        required
        onChange={handleTaskSubTypeChange}
      />

      <UrgencyIdField name="urgency" required />

      <PrecautionFields {...props} />

      <RadioButtonField name="leadVests" flat />

      <RadioButtonField name="supports" flat />

      <TextareaField name="additionalInfo" maxLength={300} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export default OperatingRoomCleanForm;
